import { render, staticRenderFns } from "./TaskStatusDisplay.vue?vue&type=template&id=3b22c566&scoped=true&"
import script from "./TaskStatusDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskStatusDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusDisplay.vue?vue&type=style&index=0&id=3b22c566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b22c566",
  null
  
)

export default component.exports